import { ContestDisplay } from "../contest";
import GwParticipants from "../gw_participants";
import GiveawayTimer from "../gw_timer";
import Nyeremenyjatek from "../nyeremenyjatek";
import TwitchChat from "../twitch_chat";
import Karma from "../karma";
import { RainOverlay } from "../Rain";
import { BarkobaOverlay } from "../WordGame";
import { BidAuction } from "../BidAuction";
import Hotword from "../hotword/hotword";

export default function RightPanel({
  greenScreen,
  activeContest,
  participants = [], // NOSONAR
  participantBoosts = {},
  keyword,
  nyeremenyJatekData,
  removeNyWinner,
  gwTimer,
}) {
  const hasGiveaway = participants.length > 0 || !!gwTimer;
  const hasPanelContent = hasGiveaway || nyeremenyJatekData;

  return (
    <div className="right">
      <span className={`camera of rounded-3xl ${greenScreen ? "green" : ""}`} />

      {/* Chat area — Karma, RainOverlay, BarkobaOverlay & BidAuction overlay this when active */}
      <div className="chat rounded-3xl relative overflow-hidden">
        <TwitchChat />
        <Karma />
        <RainOverlay enabled={true} />
        <BarkobaOverlay />
        <BidAuction />
      </div>

      {activeContest && (
        <div className="flex flex-row justify-center items-center">
          <ContestDisplay data={activeContest} />
        </div>
      )}

      {/* Side panel — Hotword overlays everything; contest/giveaway shows beneath */}
      <div className="hot-word rounded-3xl relative overflow-hidden flex flex-col">
        {hasPanelContent ? (
          <>
            <div className="flex flex-row justify-center items-center flex-1">
              {hasGiveaway && (
                <GwParticipants
                  usernames={participants}
                  boosts={participantBoosts}
                  keyword={keyword}
                />
              )}
              {nyeremenyJatekData && (
                <Nyeremenyjatek
                  nyeremenyjatekData={nyeremenyJatekData}
                  removeWinner={removeNyWinner}
                />
              )}
            </div>
            {hasGiveaway && (
              <div className="flex w-full px-4 h-8 text-left left-0 mt-[-12px] justify-evenly">
                <div>👤{participants.length}</div>
                {gwTimer && <GiveawayTimer startTime={gwTimer} />}
              </div>
            )}
          </>
        ) : null}
        <Hotword />
      </div>
    </div>
  );
}

// import { ContestDisplay } from "../contest";
// import GwParticipants from "../gw_participants";
// import GiveawayTimer from "../gw_timer";
// import Nyeremenyjatek from "../nyeremenyjatek";
// import TwitchChat from "../twitch_chat";
// import Karma from "../karma";
// import Hotword from "../hotword/hotword";

// export default function RightPanel({
//   greenScreen,
//   activeContest,
//   participants = [], // NOSONAR
//   keyword,
//   nyeremenyJatekData,
//   removeNyWinner,
//   gwTimer,
// }) {
//   return (
//     <div className="right">
//       <span className={`camera of rounded-3xl ${greenScreen ? "green" : ""}`} />

//       <div className="chat rounded-3xl relative overflow-hidden">
//         <TwitchChat />
//         <Karma />
//       </div>

//       <div className="hot-word rounded-3xl ">
//         <div className="flex flex-row justify-center items-center">
//           <ContestDisplay data={activeContest} />
//           <GwParticipants usernames={participants} keyword={keyword} />
//           {nyeremenyJatekData && (
//             <Nyeremenyjatek
//               nyeremenyjatekData={nyeremenyJatekData}
//               removeWinner={removeNyWinner}
//             />
//           )}
//         </div>
//         <div className="flex w-full px-4 h-8 text-left left-0 mt-[-12px] justify-evenly">
//           <div>👤{participants.length}</div>
//           {gwTimer && <GiveawayTimer startTime={gwTimer} />}
//         </div>
//         <Hotword />
//       </div>
//     </div>
//   );
// }
